import { z } from "zod";

const envSchema = z.object({
  serviceUrl: z.string({
    invalid_type_error:
      "🚨 [serviceUrl] 'NEXT_PUBLIC_SERVICE_URL' 환경변수 타입이 문자열(string)이 아닙니다.",
  }).optional(),

  nodeEnv: z.string({
    invalid_type_error:
      "🚨 [nodeEnv] 'NEXT_PUBLIC_NODE_ENV' 환경변수 타입이 문자열(string)이 아닙니다.",
  }).optional(),

  awsStorageBucketName: z.string({
    invalid_type_error:
      "🚨 [awsStorageBucketName] 'NEXT_PUBLIC_AWS_STORAGE_BUCKET_NAME' 환경변수 타입이 문자열(string)이 아닙니다.",
  }).optional(),
});

export const ENV = envSchema.parse({
  serviceUrl: process.env.NEXT_PUBLIC_SERVICE_URL,
  nodeEnv: process.env.NEXT_PUBLIC_NODE_ENV,
  awsStorageBucketName: process.env.NEXT_PUBLIC_AWS_STORAGE_BUCKET_NAME,
});
